import axios from 'src/utils/axios';

export const GET_PHONE_NUMBERS = '@phoneNumbers/get-phone-numbers';

export function getPhoneNumbers() {
  const request = axios.get('/api/admin/phone-numbers');
  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_PHONE_NUMBERS,
        payload: response.data,
      })
    );
  };
}

export function registerPhoneNumber(botId) {
  return async dispatch => {
    const response = await axios.post(
      `/api/admin/phone-numbers/${botId}/register`
    );
    dispatch(getPhoneNumbers());
    return response.data;
  };
}

export function deregisterPhoneNumber(botId) {
  return async dispatch => {
    const response = await axios.post(
      `/api/admin/phone-numbers/${botId}/deregister`
    );
    dispatch(getPhoneNumbers());
    return response.data;
  };
}
